module.exports = __webpack_public_path__ + "93d6ded8a0c8892760659d102a06879c.svg";